/* Shared VAULT recommendations: home and product placement. */
(function () {
  'use strict';
  // Re-run by the preloader's soft page swap: draw the new page's rows (they were empty)
  if (window.VaultRecommendations) { window.VaultRecommendations.init(); return; }

  const STYLE = ['streetwear', 'casual', 'y2k', 'grunge', 'opium', 'dark avant', 'business core', 'vintage', 'formal', 'athleisure', 'minimalist', 'preppy', 'gothic', 'old money', 'acubi', 'gorpcore', 'soft girl', 'starboy'];
  const FANDOM = ["a'tin", 'sb19', 'enhypen', 'ehypen', 'engene', 'ni-ki', 'niki', 'felip', 'josh', 'ken', 'bts', 'army', 'blackpink', 'blink', 'kpop', 'marvel', 'anime', 'disney', 'seventeen', 'carat', 'twice', 'once', 'aespa', 'stray kids', 'stay', 'nct', 'nctzen'];
  const BRAND = ['acne studio', 'balenciaga', 'chrome hearts', 'gap', 'rick owens', 'supreme', 'vetements', 'yeezy', 'nike', 'adidas', 'gucci', 'prada', 'off-white', 'maison margiela', 'diesel', 'enfants riches'];
  const PART = {
    top: ['tops', 'shirt', 'tshirt', 't-shirt', 'tee', 'jersey', 'hoodie', 'sweater', 'sweatshirt', 'long sleeve', 'short sleeve', 'blouse', 'tank', 'polo', 'crop top'],
    bottom: ['bottom', 'pants', 'shorts', 'skirt', 'jeans', 'cargo', 'trouser', 'legging'],
    footwear: ['footwear', 'shoe', 'sneaker', 'boot', 'sandal', 'slipper', 'low top', 'high top', 'high-top', 'low-top', 'knee-high', 'knee high', 'loafer'],
    accessories: ['accessor', 'caps', 'beanie', 'bucket', 'bag', 'belt', 'wallet', 'sock', 'watch', 'sunglass', 'eyewear', 'headwear', 'jewelry', 'jewellery', 'necklace', 'scarf', 'boxer', 'earring', 'bracelet']
  };
  const OUTER = ['outwear', 'outerwear', 'jacket', 'coat', 'blazer', 'parka', 'windbreaker', 'cape'];
  const COLORS = new Set(['black', 'white', 'red', 'blue', 'green', 'yellow', 'pink', 'purple', 'orange', 'brown', 'grey', 'gray', 'beige', 'navy', 'tan', 'cream', 'olive', 'khaki', 'silver', 'gold', 'maroon', 'burgundy', 'ivory', 'charcoal']);
  const PRODUCT_SLOTS = {
    top: ['accessories', 'bottom', 'footwear', 'top'],
    bottom: ['accessories', 'top', 'footwear', 'outerwear'],
    footwear: ['accessories', 'top', 'bottom', 'outerwear'],
    accessories: ['top', 'accessories', 'bottom', 'footwear'],
    outerwear: ['accessories', 'bottom', 'footwear', 'top']
  };
  // STYLE WITH (product page) on an accessory: outfit pieces first, so the two cards a phone
  // shows are never another accessory. The homepage keeps PRODUCT_SLOTS unchanged.
  const STYLE_WITH_SLOTS = { ...PRODUCT_SLOTS, accessories: ['top', 'bottom', 'accessories', 'footwear'] };
  const FALLBACK = {
    top: ['outerwear', 'bottom', 'footwear', 'accessories'],
    bottom: ['outerwear', 'top', 'footwear', 'accessories'],
    footwear: ['bottom', 'top', 'outerwear', 'accessories'],
    outerwear: ['top', 'bottom', 'footwear', 'accessories'],
    accessories: ['top', 'bottom', 'footwear', 'outerwear']
  };

  const norm = value => String(value || '').toLowerCase();
  const tags = product => Array.isArray(product.tags) ? product.tags.map(norm) : String(product.tags || '').split(',').map(norm);
  const has = (values, key) => values.some(value => value.includes(key));
  const unique = values => [...new Set(values)];
  const tracker = () => window.BehaviorTracker;
  const parse = (text, fallback) => { try { return JSON.parse(text); } catch (_) { return fallback; } };
  const money = cents => new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP', maximumFractionDigits: 0 }).format(cents / 100);
  const escape = text => String(text || '').replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]));

  function category(product) {
    const t = tags(product);
    if (has(t, 'footwear') || PART.footwear.some(key => has(t, key))) return 'footwear';
    if (PART.accessories.some(key => has(t, key))) return 'accessories';
    if (PART.bottom.some(key => has(t, key))) return 'bottom';
    if (OUTER.some(key => has(t, key))) return 'outerwear';
    if (PART.top.some(key => has(t, key))) return 'top';
    return null;
  }
  function designKey(product) {
    return norm(product.title).split(/[\s\-\/_.,()|]+/).filter(token => token && !COLORS.has(token)).join('').replace(/[^a-z0-9]/g, '');
  }
  function signals(items) {
    const out = {};
    for (const [axis, dictionary, single] of [['style', STYLE, .6], ['fandom', FANDOM, .7], ['brand', BRAND, .5]]) {
      const counts = new Map();
      for (const item of items) {
        const hit = dictionary.find(key => has(tags(item), key));
        if (hit) counts.set(hit, (counts.get(hit) || 0) + 1);
      }
      out[axis] = [...counts].map(([key, count]) => ({ key, confidence: count > 1 ? 1 : counts.size > 1 ? .3 : single }));
    }
    return out;
  }
  function axisScore(productTags, axisSignals, points) {
    return axisSignals.reduce((best, signal) => has(productTags, signal.key) ? Math.max(best, signal.confidence * points) : best, 0);
  }
  function score(product, prefs, autoIds, manualIds) {
    const t = tags(product), behavior = tracker();
    const id = Number(product.id);
    return axisScore(t, prefs.style, 6) + axisScore(t, prefs.fandom, 6) + axisScore(t, prefs.brand, 3)
      + (behavior && behavior.scoreFor ? behavior.scoreFor(id) : 0)
      + (autoIds.has(id) ? 2 : 0) + (manualIds.has(id) ? 2 : 0)
      + (Number(product.inventory) > 0 && Number(product.inventory) <= 5 ? 1 : 0)
      + (behavior && behavior.removalPenalty ? behavior.removalPenalty(id) : 0)
      + (behavior && behavior.impressionPenalty ? behavior.impressionPenalty(id) : 0);
  }
  function eligible(product, excluded, usedDesigns, hideComingSoon) {
    const id = Number(product.id), behavior = tracker();
    return id && !excluded.has(id) && product.available && Number(product.price) > 0
      && (!hideComingSoon || !tags(product).some(tag => tag.trim() === 'coming soon'))
      && !(behavior && behavior.isHidden && behavior.isHidden(id))
      && !usedDesigns.has(designKey(product));
  }
  function rank(pool, prefs, autoIds, manualIds, excluded, usedDesigns, hideComingSoon) {
    return pool.filter(p => eligible(p, excluded, usedDesigns, hideComingSoon))
      .map((p, index) => ({ p, index, score: score(p, prefs, autoIds, manualIds) }))
      .sort((a, b) => b.score - a.score || a.index - b.index);
  }
  // Slot category wins whenever it has an eligible product; fallback only when it is empty.
  function chooseSlot(slot, catalog, prefs, autoIds, manualIds, excluded, usedDesigns, hideComingSoon) {
    for (const key of [slot, ...FALLBACK[slot]]) {
      const best = rank(catalog.filter(p => category(p) === key), prefs, autoIds, manualIds, excluded, usedDesigns, hideComingSoon)[0];
      if (best) return best.p;
    }
    return null;
  }
  function add(p, selected, excluded, designs) {
    if (!p) return;
    selected.push(p); excluded.add(Number(p.id));
    designs.add(designKey(p));
  }
  function visibleRecentlyViewed() {
    const ids = new Set(), handles = new Set();
    document.querySelectorAll('*').forEach(element => {
      if (!element.localName || !element.localName.startsWith('recently-viewed-')) return;
      element.querySelectorAll('[data-product-id], [data-product-handle]').forEach(card => {
        if (card.dataset.productId) ids.add(Number(card.dataset.productId));
        if (card.dataset.productHandle) handles.add(card.dataset.productHandle);
      });
    });
    return { ids, handles };
  }
  async function homeAnchors(data) {
    if (data.cartItems.length) return data.cartItems;
    let handles = [];
    try { handles = parse(localStorage.getItem('ai_recently_viewed_products'), []).slice(0, 6); } catch (_) {}
    const results = await Promise.all(handles.map(handle => fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(response => response.ok ? response.json() : null).catch(() => null)));
    return results.filter(Boolean);
  }
  // Shopify CDN photos at card size (the raw file was a multi-MB PNG: Safari left Style with cards blank white);
  // same file name, so flights still match the photo.
  const sized = u => u && /\/cdn\/shop\/|cdn\.shopify\.com/.test(u) && !/[?&]width=/.test(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600' : u;
  function card(product, id) {
    const image = sized(product.image || ''), hover = sized(product.hover_image || '') || image;
    const hasHover = !!(hover && image && hover !== image);
    const price = Number(product.price) || 0, compare = Number(product.compare_at_price) || 0;
    const classes = name => 'ai-suggested-product-' + name + '-' + id;
    // data-ql-variant opts the card into VAULT quick add (assets/vault-quick-lock.js).
    const quick = product.available !== false && product.variant_id ? ' data-ql-variant="' + Number(product.variant_id) + '"' : '';
    return '<div class="' + classes('card') + '" data-product-id="' + Number(product.id) + '" data-product-handle="' + escape(product.handle) + '" data-image-fallback="' + escape(image) + '"' + quick + '>'
      + '<a href="' + escape(product.url) + '" class="' + classes('link') + '">'
      + '<div class="' + classes('image-wrapper') + '">'
      + (image ? '<img src="' + escape(image) + '" alt="' + escape(product.title) + '" class="' + classes('image') + ' no-lazy tinyimg-exclude" loading="eager" decoding="async" width="400" height="400">'
        + (hasHover ? '<img src="' + escape(hover) + '" alt="" class="' + classes('image-hover') + ' no-lazy tinyimg-exclude" loading="eager" decoding="async" width="400" height="400">' : '') : '')
      + '</div><div class="' + classes('info') + '"><h3 class="' + classes('title') + '">' + escape(product.title) + '</h3>'
      + '<div class="' + classes('price') + '">'
      + (compare > price ? '<span class="' + classes('price-compare') + '">' + money(compare) + '</span>' : '')
      + '<span class="' + classes('price-regular') + '">' + money(price) + '</span></div></div></a></div>';
  }
  async function render(root) {
    const dataNode = document.querySelector('.vault-recs-data[data-for="' + root.dataset.recsId + '"]');
    if (!dataNode) return;
    const data = parse(dataNode.textContent, null);
    if (!data) return;
    const mode = root.dataset.recsMode, id = root.dataset.recsId;
    const limit = mode === 'product' ? 4 : 8;
    const hideComingSoon = true; // R40: tagged products stay out of Recommended and Style With.
    const catalog = [...new Map(Object.values(data.pools || {}).flat().map(p => [Number(p.id), p])).values()];
    const byId = new Map(catalog.map(p => [Number(p.id), p]));
    const toProduct = item => item && typeof item === 'object' ? item : byId.get(Number(item));
    const auto = (data.auto || []).map(toProduct).filter(Boolean), manual = (data.manual || []).map(toProduct).filter(Boolean);
    const autoIds = new Set(auto.map(p => Number(p.id))), manualIds = new Set(manual.map(p => Number(p.id)));
    const excluded = new Set(), designs = new Set(), selected = [];
    // Only the newest render may draw, and it reads Recently Viewed after the anchor fetch.
    const ticket = root.vaultTicket = (root.vaultTicket || 0) + 1;
    const anchors = mode === 'product' ? [data.product].filter(Boolean) : await homeAnchors(data);
    if (ticket !== root.vaultTicket) return;
    const rv = mode === 'home' ? visibleRecentlyViewed() : { ids: new Set(), handles: new Set() };
    for (const value of rv.ids) excluded.add(value);
    for (const item of data.cartItems || []) excluded.add(Number(item.id));
    if (data.product && data.product.id) { excluded.add(Number(data.product.id)); designs.add(designKey(data.product)); }
    const recentBought = tracker() && tracker().recentPurchases ? tracker().recentPurchases(90) : new Set();
    for (const value of recentBought) excluded.add(Number(value));
    for (const value of data.purchasedIds || []) excluded.add(Number(value));
    const prefs = signals(anchors);
    const personalized = anchors.length > 0 || (tracker() && (tracker().all || (() => []))().length > 0);
    const bestsellers = [];
    for (let i = 0; i < Math.max(auto.length, manual.length); i++) {
      if (auto[i]) bestsellers.push(auto[i]);
      if (manual[i]) bestsellers.push(manual[i]);
    }
    const candidates = [...bestsellers, ...catalog.filter(p => category(p))];

    if (mode === 'product' && data.product) {
      const cat = category(data.product) || 'top';
      for (const slot of STYLE_WITH_SLOTS[cat]) add(chooseSlot(slot, catalog, prefs, autoIds, manualIds, excluded, designs, hideComingSoon), selected, excluded, designs);
    } else if (personalized) {
      const lead = category(anchors[0] || {}) || 'top';
      const sequence = [...PRODUCT_SLOTS[lead], ...PRODUCT_SLOTS[lead]];
      for (const slot of sequence) add(chooseSlot(slot, catalog, prefs, autoIds, manualIds, excluded, designs, hideComingSoon), selected, excluded, designs);
    }
    // Cold start and any unfilled slots use the real 30-day and curated lists.
    for (const source of [bestsellers, candidates]) {
      for (const p of source) {
        if (selected.length >= limit) break;
        if (rv.handles.has(p.handle)) continue;
        if (eligible(p, excluded, designs, hideComingSoon)) add(p, selected, excluded, designs);
      }
    }
    // Keep the homepage separate from the products that actually rendered above.
    const final = selected.filter(p => !rv.ids.has(Number(p.id)) && !rv.handles.has(p.handle)).slice(0, limit);
    const wrapper = root.parentElement && root.parentElement.parentElement;
    if (watcher) root.querySelectorAll('[data-product-id]').forEach(element => watcher.unobserve(element));
    root.innerHTML = final.map(p => card(p, id)).join('');
    if (wrapper) wrapper.style.display = final.length ? '' : 'none';
    // Always open on slot 1 so the slot order reads left to right.
    if (root.start) root.start();
    document.dispatchEvent(new CustomEvent('vault:recommendations-rendered'));
    const box = root.getBoundingClientRect();
    if (box.top < window.innerHeight && box.bottom > 0) {
      [...root.querySelectorAll('[data-product-id]')].slice(0, 2).forEach(card => {
        const image = card.querySelector('img');
        if (image) image.loading = 'eager';
      });
    }
    root.querySelectorAll('[data-product-id]').forEach(element => {
      const productId = Number(element.dataset.productId);
      element.addEventListener('click', () => { if (tracker() && tracker().recordClick) tracker().recordClick(productId); });
      if (watcher) watcher.observe(element);
    });
  }
  // Count a card as shown only once it is half on screen, and once per page view.
  const seen = new Set();
  const watcher = window.IntersectionObserver ? new window.IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    watcher.unobserve(entry.target);
    const productId = Number(entry.target.dataset.productId);
    if (seen.has(productId)) return;
    seen.add(productId);
    if (tracker() && tracker().recordImpression) tracker().recordImpression(productId);
  }), { threshold: 0.5 }) : null;
  // Scroll instantly, even where the CSS asks for smooth scrolling.
  function jump(row, x) {
    const behavior = row.style.scrollBehavior;
    row.style.scrollBehavior = 'auto';
    row.scrollLeft = x;
    row.style.scrollBehavior = behavior;
  }
  // Endless row both ways, like a mirror: swipe right for 2, 3, 4…, swipe left for 8, 7, 6…,
  // with no empty edge. Hidden cards are moved to whichever side needs them. Only a row too
  // short to fill both sides gets one extra copy of its cards (same images, nothing new loads).
  function carousel(row) {
    row.dataset.carousel = 'true';
    // Mouse/trackpad screens re-balance while scrolling; touch screens only when it is safe.
    const fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    const gap = () => parseFloat(getComputedStyle(row).columnGap) || 0;
    const centred = el => getComputedStyle(el).scrollSnapAlign.includes('center');
    // Scroll position that shows a card where it snaps: centred, or at the left edge.
    const target = el => {
      const box = row.getBoundingClientRect(), r = el.getBoundingClientRect();
      return row.scrollLeft + (centred(el) ? r.left + r.width / 2 - box.left - box.width / 2 : r.left - box.left - (parseFloat(getComputedStyle(row).paddingLeft) || 0));
    };
    // Move hidden cards so both sides keep a buffer; returns how far the view shifted.
    row.recycle = () => {
      if (!row.looping) return 0;
      const box = row.getBoundingClientRect(), rects = [...row.children].map(el => el.getBoundingClientRect());
      let moves = Math.trunc((rects.filter(r => r.right <= box.left + 1).length - rects.filter(r => r.left >= box.right - 1).length) / 2);
      if (!moves) return 0;
      let shift = 0;
      row.style.scrollSnapType = 'none';
      for (; moves > 0; moves--) { const el = row.firstElementChild; shift -= el.getBoundingClientRect().width + gap(); row.appendChild(el); }
      for (; moves < 0; moves++) { const el = row.lastElementChild; shift += el.getBoundingClientRect().width + gap(); row.insertBefore(el, row.firstElementChild); }
      jump(row, row.scrollLeft + shift);
      requestAnimationFrame(() => { row.style.scrollSnapType = ''; });
      return shift;
    };
    // Open on slot 1 (centred where the row centres cards), with cards ready on both sides.
    row.start = () => {
      row.querySelectorAll('[data-clone]').forEach(el => el.remove());
      row.looping = false;
      jump(row, 0);
      const cards = [...row.children], first = cards[0];
      if (!first || row.scrollWidth <= row.clientWidth + 1) return;
      const box = row.getBoundingClientRect();
      const seen = cards.filter(el => el.getBoundingClientRect().left < box.right).length;
      if (seen >= cards.length) return;
      // Spare cards beyond the screen: a few with a mouse or trackpad, but on touch screens
      // about two screens each side, so quick swipes never reach an end. Copies reuse the
      // same images, so nothing new downloads.
      const spare = fine ? 3 : Math.max(6, 4 * seen);
      const copies = Math.min(4, Math.max(0, Math.ceil((seen + spare) / cards.length) - 1));
      for (let i = 0; i < copies; i++) cards.forEach(el => {
        const copy = el.cloneNode(true);
        copy.dataset.clone = 'true';
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        row.appendChild(copy);
      });
      row.looping = true;
      row.recycle();
      if (centred(first)) {
        row.style.scrollSnapType = 'none';
        jump(row, target(first));
        requestAnimationFrame(() => { row.style.scrollSnapType = ''; });
      }
    };
    // Re-balance once the row rests (never mid-swipe on phones, so momentum is untouched).
    // With a mouse or trackpad it can also re-balance while scrolling, so no edge is ever hit.
    let idle, queued = false;
    row.addEventListener('scroll', () => {
      if (fine && !queued) { queued = true; requestAnimationFrame(() => { queued = false; row.recycle(); }); }
      clearTimeout(idle);
      idle = setTimeout(row.recycle, 150);
    }, { passive: true });
    // A finger on the row stops it, so re-balancing then is invisible and restocks both sides.
    row.addEventListener('touchstart', () => row.recycle(), { passive: true });
    // Rebuild only when the row's width really changes (not when a phone's address bar hides).
    let width = row.clientWidth, resizing;
    window.addEventListener('resize', () => {
      clearTimeout(resizing);
      resizing = setTimeout(() => { if (row.clientWidth !== width && row.children.length) { width = row.clientWidth; row.start(); } }, 200);
    }, { passive: true });
  }
  // Mouse drag with momentum: the row keeps gliding after release and eases to a stop.
  function glide(row) {
    let down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, velocity = 0, frame = 0;
    const stop = () => cancelAnimationFrame(frame);
    const touch = () => { row.dataset.touched = 'true'; stop(); };
    // On a looping row, recycle passed cards before the end is reached; returns the shift.
    // On a looping row, move hidden cards to the side that needs them; returns the shift.
    const refill = () => row.recycle ? row.recycle() : 0;
    const coast = (previous, now) => {
      const dt = Math.min(50, now - previous), before = row.scrollLeft;
      row.scrollLeft -= velocity * dt;
      refill();
      velocity *= Math.pow(0.95, dt / 16.67);
      if (Math.abs(velocity) > 0.02 && row.scrollLeft !== before) frame = requestAnimationFrame(next => coast(now, next));
    };
    row.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      touch(); down = true; moved = false; velocity = 0;
      startX = lastX = event.clientX; startLeft = row.scrollLeft; lastT = event.timeStamp;
    });
    row.addEventListener('pointermove', event => {
      if (!down) return;
      const dx = event.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        moved = true; row.setPointerCapture(event.pointerId); row.classList.add('is-dragging');
      }
      const dt = Math.max(1, event.timeStamp - lastT);
      velocity = 0.8 * ((event.clientX - lastX) / dt) + 0.2 * velocity;
      lastX = event.clientX; lastT = event.timeStamp;
      row.scrollLeft = startLeft - dx;
      startLeft += refill();
    });
    const release = event => {
      if (!down) return;
      down = false; row.classList.remove('is-dragging');
      if (moved && event.timeStamp - lastT < 80) frame = requestAnimationFrame(now => coast(now - 16.67, now));
    };
    row.addEventListener('pointerup', release);
    row.addEventListener('pointercancel', release);
    // A drag is not a click: keep the product link from opening after a drag.
    row.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
    row.addEventListener('dragstart', event => event.preventDefault());
    row.addEventListener('wheel', touch, { passive: true });
    row.addEventListener('touchstart', touch, { passive: true });
  }
  function init() {
    document.querySelectorAll('[data-recs-mode][data-recs-id]').forEach(root => {
      if (root.dataset.vaultInitialized) return;
      root.dataset.vaultInitialized = 'true';
      carousel(root);
      render(root);
      if (root.dataset.recsMode === 'home') {
        glide(root);
        let timer;
        const rerender = () => { clearTimeout(timer); timer = setTimeout(() => render(root), 100); };
        const rv = [...document.querySelectorAll('*')].find(el => el.localName && el.localName.startsWith('recently-viewed-'));
        if (rv) new MutationObserver(rerender).observe(rv, { childList: true });
        window.addEventListener('ai-rv-updated', rerender);
      }
    });
  }
  window.VaultRecommendations = { init, render, glide };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
